import { useEffect } from "react";

// Sets per-route <title> and meta description for SEO in this SPA.
export default function useDocumentTitle(title, description) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            let tag = document.querySelector('meta[name="description"]');
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("name", "description");
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", description);
        }
    }, [title, description]);
}
